import React, { useState } from 'react'
import '../Styles/Main.css'
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
import Joker from './Joker.png';
import Music from './The Weeknd - I Was Never There (intro looped).mp3'

export const Main = () => {

    useEffect(() => {
        //audio
        let music = document.querySelector("audio")
        let btn = document.querySelector(".play")
        let offbtn = document.querySelector(".off")
        btn.addEventListener("click", () => {
            music.play()
            btn.style.display = "none"
            offbtn.style.display = "flex"
        })
        offbtn.addEventListener("click", () => {
            music.pause()
            btn.style.display = "flex"
            offbtn.style.display = "none"
        })
  
        // menu
        let bars = document.querySelector("i.fa-bars")
        let x = document.querySelector("i.fa-x")
        let header = document.querySelector('.header-width')
        let menu = document.querySelector('.menu')
        bars.addEventListener("click", () => {
            bars.style.display = "none"
            x.style.display = "block"
            header.style.display = "block"
            menu.style.background = "none"
        })
        x.addEventListener("click", () => {
            bars.style.display = "block"
            x.style.display = "none"
            header.style.display = "none"
            menu.style.background = "#0c0f15c9"
        })
        Aos.init({ duration: 2000 });

    }, [])

    return (
        <>
            <audio src={Music} ></audio>
            <main>
                <div className="audio-btns">
                    <button className='play'><ion-icon name="musical-notes-outline" id="ringtone"></ion-icon> <span>play</span> </button>
                    <button className='off'><ion-icon name="pause-circle-outline"></ion-icon>Off</button>
                </div>
                <img src={Joker} alt="" />
                <div className="menu">
                    <i className="fa-solid fa-x"></i>
                    <i className="fa-solid fa-bars"></i>
                </div>
                <div className="container" data-aos="fade-up">

                    <div>

                        <h1 className="hi" data-splitting>
                            <span>
                                <span className="blast">H</span>
                                <span className="blast"> i </span>
                                <span className="blast"> , </span>
                            </span>

                            <br />
                            <span>
                                <span className="blast">I</span>
                                <span className="blast">'</span>
                                <span className="blast">m</span>
                                ⠀
                            </span>
                            <span>
                                <span className="blast">O</span>
                                <span className="blast">z</span>
                                <span className="blast">o</span>
                                <span className="blast">d</span>
                                <span className="blast"> , </span>
                            </span>
                            ⠀⠀ ⠀ ⠀

                            <br />
                            <span className="blast">w</span>
                            <span className="blast">e</span>
                            <span className="blast">b</span>
                            ⠀⠀ ⠀
                            <span className="blast">d</span>
                            <span className="blast">e</span>
                            <span className="blast">v</span>
                            <span className="blast">e</span>
                            <span className="blast">l</span>
                            <span className="blast">o</span>
                            <span className="blast">p</span>
                            <span className="blast">e</span>
                            <span className="blast">r</span>
                        </h1>
                        <p className="gray-text " data-splitting>Full Stack developer / Mern Stack developer</p>
                        <br />

                            <a href="#" className="contact-button">
                                <div>
                                    <span className="bg" ></span>
                                    <span className="base"></span>
                                    <span className="text">
                                        Contact me!
                                    </span>
                                </div>
                            </a>
                    </div>
                </div>
            </main>
        </>
    )
}
